import { render, staticRenderFns } from "./newsUpdate.vue?vue&type=template&id=5592128a&scoped=true&"
import script from "./newsUpdate.vue?vue&type=script&lang=js&"
export * from "./newsUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5592128a",
  null
  
)

export default component.exports